// 全局配置文件
export const API_BASE_URL = 'https://test.1023549645.workers.dev';

// API 端点
export const API_ENDPOINTS = {
  ITEMS_CSV: `${API_BASE_URL}/Item.csv`,
  ITEM_PRICE: `${API_BASE_URL}/`,
  SUGGESTION: `${API_BASE_URL}/suggestion`,
};